export enum FormSetupCoverEnum {
  ExampleSetup = 'exampleSetup.svg',
  AtHomeSetup = 'atHomeSetup.svg',
  AutomationSetup = 'automationSetup.svg',
  SanitaryInstallationSetup = 'sanitaryInstallationSetup.svg',
  HeatingInstallationSetup = 'heatingInstallationSetup.svg',
  ResourceSetup = 'resourceSetup.svg',
  ReguardSetup = 'reguardSetup.svg',
}
